// extracted by mini-css-extract-plugin
export default {"donateBtn":"DonateButton_donateBtn__gMdkC"};